module.exports = __webpack_public_path__ + "img/lb_menu_bg_a_r.84071338.png";